<template>
  <div v-if="show" id="inventoryCheck">
    <div class="inventoryCheck_msg">
      <van-image width="3rem" height="2.3rem"
                 src="https://oss.xiaoyi120.com/BDxcx/inventory/confirm_img.png"
                 style="margin-top:3rem"
      />
      <div class="msg_01">哎呀~这不是您的账单</div>
      <div class="msg_02">请确认账号登录状态！重新登录试试~</div>
      <br><br>
    </div>
    <div class="inventoryCheck_btn">
      <div class="inventoryCheck_reLogin" @click="loginOut">重新登录</div>
    </div>
  </div>
</template>

<script>
import { checkOrderExpress } from '@/api/linkPage'
export default {
  data() {
    return {
      show: false,
      backendTakingId: '',
      type: 3,
      path: ''
    }
  },
  created() {
    this.type = this.$route.query.storeOrderApiType
    this.backendTakingId = this.$route.query.storeOrderExpressId
    this.path = this.$route.path + '?storeOrderApiType=' + this.$route.query.storeOrderApiType + '&storeOrderExpressId=' + this.$route.query.storeOrderExpressId
    console.log('this.path', this.path)
    this.checkUser(this.backendTakingId, this.type)
  },
  methods: {
    checkUser(id, type) {
      checkOrderExpress({ storeOrderExpressId: this.backendTakingId, storeOrderApiType: this.type }).then(res => {
        this.$router.push('/linkPage/comfirmExpress?storeOrderExpressId=' + id + '&storeOrderApiType=' + type)
      }).catch(() => { this.show = true })
    },
    loginOut() {
      sessionStorage.removeItem('jump')
      sessionStorage.setItem('shareUrl', this.path)
      var url = '#' + this.path
      window.location.replace(url)
      this.$router.replace({ path: '/user/login' })
    }

  }
}
</script>

<style lang="scss">
#inventoryCheck {
  width: 100%;
  height: 18rem;
  background-image: url(https://oss.xiaoyi120.com/BDxcx/inventory/confirm_bg.png);
  background-size: 100%;
  background-repeat: no-repeat;
  background-color: rgb(200, 222, 255);

  .inventoryCheck_msg {
    width: 100%;
    height: 6rem;
    background-image: url(https://oss.xiaoyi120.com/BDxcx/inventory/confirm_box.png);
    background-size: 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .msg_01 {
      font-size: 0.5rem;
      font-weight: bold;
      color: #15355c;
      margin-top: 0.2rem;
    }
    .msg_02 {
      font-size: 0.3rem;
      font-weight: 400;
      color: #15355c;
      margin-top: 0.2rem;
    }
  }
  .inventoryCheck_btn {
    width: 6rem;
    height: 1rem;
    background: linear-gradient(8deg, #159cf8 0%, #3c7cff 100%);
    border-radius: 0.5rem;
    margin-left: 2rem;
    margin-top: 5rem;
    text-align: center;
    .inventoryCheck_reLogin {
      font-size: 0.4rem;
      font-weight: 400;
      line-height: 1rem;
      color: #ffffff;
    }
  }
}
</style>
